<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Entidades</li>
</ol>

<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Entidades</small></h1>


@if(!entity && !showEditEntity){
<div class="scrollable">
    <panel [noButton]="true">

        <div class="">
            <h5>Listado de Entidades</h5>

            <div class="d-flex justify-content-between align-items-center">
                <input type="text" class="form-control form-control-sm w-75"
                    (keyup)="filterEntities($event.target.value)" placeholder="Buscar por nombre...">
                <button class="btn btn-success btn-xs" (click)="addEntity()"> <i class="fas fa-plus"></i> Nuevo</button>
            </div>
        </div>

        <div class="panel-body my-3">
            <div class="row table-scrollable modal-body table-container">
                <table class="table table-sm table-hover table-striped">
                    <thead>
                        <th class="text-center">N°</th>
                        <th class="text-center">Código</th>
                        <th class="text-center">Nombre</th>
                        <th class="text-center">Grupo</th>
                        <th class="text-center">Campo</th>
                        <th class="text-center">Auditor</th>
                        <th class="text-center">Habilitado</th>
                        <th class="text-center"><i class="fas fa-cogs"></i></th>

                    </thead>

                    <tbody>
                        @if(entities?.length > 0){
                        @for(entity of entities; track $index){
                        <tr [ngClass]="{ 'bg-danger': !entity.enabled }">
                            <td class="text-center">{{ $index + 1 }}</td>
                            <td class="text-center">{{ entity.code }}</td>
                            <td class="text-center">{{ entity.name }}</td>
                            <td class="text-center">{{ entity.group?.name }}</td>
                            <td class="text-center">{{ entity.office?.acronym }}</td>
                            <td class="text-center">{{ entity.auditor?.displayName }}</td>
                            <td>
                                <div class="form-check form-switch d-flex justify-content-center">
                                    <input class="form-check-input" type="checkbox" id="checkbox1"
                                        [checked]="entity.enabled" (change)="activeDeactiveEntity(entity)" />
                                </div>
                            </td>
                            <td class="text-center">
                                <button class="btn btn-primary btn-xs mx-1" (click)="setEditEntity(entity)"><i class="fas fa-edit"></i></button>
                               
                            </td>
                        </tr>
                        }
                        }
                        @else{
                        <tr>
                            <td colspan="8" class="text-center">No hay registros para mostrar.</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>


    </panel>
</div>
}@else{
<ng-container>
    <app-edit-entity [entity]="entity" [auditors]="auditors" (close)="showEditEntity = false; entity = null"
        (update)="getEntities()"></app-edit-entity>
</ng-container>
}